import Furnace from '@/models/Furnace'
import User, { hasRole, Role } from '@/models/User'

export default class FurnacePolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, furnace: Furnace) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === furnace.entry.catalog.company.id
			case Role.AUDITOR:
				return furnace.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, furnace: Furnace) {
		return hasRole(user, Role.USER) && user.company?.id === furnace.entry.catalog.company.id
	}

	restore(user: User, furnace: Furnace) {
		return hasRole(user, Role.USER) && user.company?.id === furnace.entry.catalog.company.id
	}

	delete(user: User, furnace: Furnace) {
		return hasRole(user, Role.USER) && user.company?.id === furnace.entry.catalog.company.id
	}

	forceDelete(_user: User, _furnace: Furnace) {
		return false
	}
}
